// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import myw from 'myWorld/base/core';
import 'myWorld/base/control';
import 'jquery-ui';
import 'myWorld/controls/search/suggestionItemView';
import 'myWorld/controls/search/suggestionQueryView';

myw.SuggestionListView = myw.Control.extend({
    tagName: 'div',
    className: 'search-results',

    events: {
        mousedown: 'cancelBlur'
    },
    /*
     * @class Responsible for rendering the list with autocomplete suggestions <br/>
     * @param  {Application}  owner
     * @param  {jQueryElement}    options.underneath  The search input element used to position the examples view
     * @constructs
     * @extends {Control}
     */
    initialize(owner, options) {
        myw.Control.prototype.initialize.call(this, owner, options);

        this.list = $('<ul>').addClass('noStyleList');

        this.$el.append(this.list).appendTo('body');

        myw.appReady.then(() => {
            const underneathEl = this.options.underneath,
                top = underneathEl.offset().top + underneathEl.outerHeight();
            this.$el.css({
                top: top,
                left: underneathEl.offset().left
            });
            this._setListHeight(top);
            this.owner._setContainerWidth(this.$el);

            $(window).resize(() => {
                this._setListHeight(top);
            });
        });

        this.render();

        this.list.scroll(() => {
            //We want to close any open sub-menu
            //Since it is left hanging in its initial position while scrolling on touch devices
            this.owner.hideSubMenu();
        });
    },
    _setListHeight(top) {
        const buffer = this.owner.isFullscreen ? 12 : 10;
        this.$el.css('max-height', $(window).height() - top - buffer);
        this.list.css('max-height', 'inherit');
    },

    render() {
        //clear previous dom elements, removing event listeners
        if (this._views) _.invoke(this._views, 'remove');
        this._views = [];

        this.list.empty();
        this.list.scrollTop(0);

        this._index = 0;
        _.each(this.owner.providers, provider => this.renderProvider(provider));
        //Delete any cached highlightedSubIndex since the sub menus will be hidden initially
        delete this.owner.highlightedSubIndex;
    },

    renderProvider(provider) {
        let header;
        const suggestions = provider.suggestions;

        if (provider.title && (suggestions && suggestions.length > 0)) {
            header = $('<li/>')
                .addClass('provider-title')
                .append($('<div/>').text(provider.title));

            if (provider.attribution)
                header.append(
                    $('<img/>', { src: myw.baseUrl + _.result(provider, 'attribution') })
                );

            this.list.append(header);
        }

        let suggestionView;

        _.each(provider.suggestions, suggestion => {
            const options = {
                    index: this._index,
                    suggestion: suggestion,
                    owner: this.owner,
                    type: provider.type,
                    isFullscreen: this.owner.isFullscreen
                },
                isSingleQuery = _.isArray(suggestion) && suggestion.length === 1;

            if (isSingleQuery) options.suggestion = suggestion[0];

            suggestionView =
                _.isArray(suggestion) && !isSingleQuery
                    ? new myw.SuggestionQueryView(options)
                    : new myw.SuggestionItemView(options);
            this._views.push(suggestionView);

            this.list.append(suggestionView.$el);

            this._index++;
        });
    },

    cancelBlur(e) {
        this.owner.cancelBlur = true;
    },
    /*
     * Refreshes the width of the list and hides any open sub menus
     * @param  {integer} width Width of the search text input
     */
    refresh() {
        this.owner._setContainerWidth(this.$el);
    }
});
export default myw.SuggestionListView;
